import { IErrorMessage, NestedErrorMessage } from "@advapacs/common";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState = {
  dateFormatLoading: false,
  errorMessage: null as IErrorMessage | NestedErrorMessage | null,
};

const generalSettingSlice = createSlice({
  name: "study",
  initialState,
  reducers: {
    updateDateTimeFormatStart(state) {
      state.dateFormatLoading = true;
    },
    updatedDateTimeFormatSuccess(state) {
      state.dateFormatLoading = false;
    },
    updateDateTimeFormatFailed(
      state,
      action: PayloadAction<NestedErrorMessage>
    ) {
      state.dateFormatLoading = false;
      state.errorMessage = action.payload;
    },
  },
});

export const SettingGeneralAction = generalSettingSlice.actions;
export default generalSettingSlice.reducer;
